import React from "react";
import { steps, testimonials } from "../../mock";
import { Quote, Star } from "lucide-react";

export default function Process() {
  return (
    <>
      {/* Process */}
      <section id="process" className="bg-brand-sand py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="reveal flex flex-col gap-3">
            <span className="kicker text-brand-teal">03 / How it works</span>
            <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight max-w-xl">
              Simple, straight and on time.
            </h2>
          </div>

          <div className="mt-14 grid gap-6 md:grid-cols-3">
            {steps.map((s, i) => (
              <div
                key={s.n}
                className="reveal relative overflow-hidden rounded-2xl border border-black/10 bg-brand-cream p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/5"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <span className="font-display text-6xl font-semibold text-brand-teal/15">{s.n}</span>
                <h3 className="mt-4 font-display text-xl font-semibold">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-brand-ink/60">{s.text}</p>
                <span className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-brand-teal/5" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section id="reviews" className="bg-brand-cream py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="reveal flex flex-col gap-3">
            <span className="kicker text-brand-teal">04 / Word of mouth</span>
            <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
              <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight max-w-xl">
                What Perth locals say.
              </h2>
              <div className="flex items-center gap-3">
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={k} className="h-5 w-5 fill-brand-teal text-brand-teal" />
                  ))}
                </div>
                <span className="text-sm font-medium text-brand-ink/60">Rated 5.0 by local customers</span>
              </div>
            </div>
          </div>

          <div className="mt-14 grid gap-6 md:grid-cols-3">
            {testimonials.map((t, i) => (
              <figure
                key={t.name}
                className="reveal flex flex-col rounded-2xl border border-black/8 bg-brand-stone p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/5"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <Quote className="h-8 w-8 text-brand-teal/30" />
                <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-brand-ink/80">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-black/10 pt-5">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-teal text-sm font-semibold text-white">
                    {t.name.charAt(0)}
                  </span>
                  <span>
                    <p className="font-display font-semibold leading-tight">{t.name}</p>
                    <p className="text-sm text-brand-ink/50">{t.place}</p>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
